import { tw } from "@careinfo/tailwind";
import { useController } from "react-hook-form";

export default function ThemeDisplay({ control, name, label }) {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  const camelCaseToSpaceTitle = (value: string) => {
    let string = "";
    const name = [];
    for (let i = 0; i < value.length; i++) {
      const code = value.charCodeAt(i);
      if (code > 64 && code < 91) {
        name.push(string.charAt(0).toUpperCase() + string.substring(1));
        string = "";
      }
      string += value[i];
    }
    name.push(string.charAt(0).toUpperCase() + string.substring(1));
    return name.join(" ");
  };

  return (
    <div
      className={tw`flex flex-col justify-center items-center border border-gray-300 rounded-lg overflow-hidden`}
    >
      <label htmlFor={name}>{camelCaseToSpaceTitle(label)}</label>
      <input
        className={tw`focus:outline-none w-full h-10`}
        type="color"
        onChange={(e) => onChange(e.target.value)}
        value={value}
        id={name}
      />
      <div className="text-center w-full">{value}</div>
    </div>
  );
}
